export default "__VITE_ASSET__CizEAl5u__"